export const TOKEN_NOT_FOUND = "token-not-found"
export const TOKEN_EXPIRED = "token-expired"
export const INVALID_TOKEN = "invalid-token"
export const UNAUTHORIZED = "unauthorized"
